
import FileViewer from '@/components/FileViewer/FileViewer.vue'
import ShowInMyFolders from '@/components/Folders/ShowInMyFolders'
import MoveNodeModal from '@/components/Folders/Modals/MoveNodeModal'
import Button from '@/components/NewUiElements/Buttons/Button'
import Chatable from '@/components/FileViewerModules/Chattable/Chatable.vue'
import LoadingIcon from '@/components/common/LoadingIcon'

export default {
    name: 'File',
    components: {
        MoveNodeModal,
        FileViewer,
        Button
    },
    provide () {
        return {
            buildUrl: this.buildUrl,
            savePage: this.savePage,
            linkClick: this.linkClick,
            toast (opts) {
                this.$toast(opts)
            },
            fvAPI_HighlightCreate: this.fvAPI_HighlightCreate,
            fvAPI_HighlightUpdate: this.fvAPI_HighlightUpdate,
            fvAPI_HighlightDelete: this.fvAPI_HighlightDelete,
            fvAPI_HighlightCopy: this.fvAPI_HighlightCopy,
            fvAPI_LoadPages: this.fvAPI_LoadPages,
            fvAPI_SearchInFile: this.fvAPI_SearchInFile,
            fvAPI_DownloadFile: this.fvAPI_DownloadFile,
            fvAPI_DownloadFileLoading: this.fvAPI_DownloadFileLoading,
            fvAPI_CopySomething: this.fvAPI_CopySomething,
            fvAPI_FetchFile: this.fvAPI_FetchFile,
            user: this.$auth.user
        }
    },
    data () {
        return {
            links: [],
            extraModules: [],
            propsLoaded: false,
            data: null,
            message: null,
            modal: null,
            toast: null,
            headerHeight: null,
            downloadLoading: false,
            copyForm: new this.$vForm({
                file_hash: null,
                page_number: null,
                start_id: null,
                end_id: null
            }),
            msgs: {
                success: null,
                error: null
            }
        }
    },
    watch: {
        'msgs.success' (value) {
            if (value && this.toast !== null) {
                this.$toast.update(this.toast, {
                    content: value,
                    options: {
                        type: 'success',
                        timeout: 2000,
                        icon: true,
                        closeButton: 'button',
                        closeOnClick: false,
                        draggable: true
                    }
                })
            }
        },
        'msgs.error' (value) {
            if (value && this.toast !== null) {
                this.$toast.update(this.toast, {
                    content: value,
                    options: {
                        type: 'error',
                        timeout: 2500,
                        icon: true,
                        closeButton: 'button',
                        closeOnClick: false,
                        draggable: true
                    }
                })
            }
        }
    },
    beforeMount () {
        this.$helpers.eventBus.$on('header-bar', ({ dir, height }) => {
            if (dir === 'down') {
                this.headerMounted(0)
            } else {
                this.headerMounted(height)
            }
        })

        this.$helpers.eventBus.$on('header-mounted', (height) => {
            this.headerMounted(height)
        })
    },
    mounted () {
        this.fetchFile()
        this.headerMounted(document.querySelector('header')?.clientHeight ?? 0)
    },
    beforeDestroy () {
        this.$helpers.eventBus.$off('header-bar')
        this.$helpers.eventBus.$off('header-mounted')
    },
    methods: {
        fvAPI_FetchFile ({ fileId, pageId = undefined }) {
            return new Promise((resolve, reject) => {
                return this.$axios
                    .get(`/v1/files/${fileId}`, {
                        params: {
                            page: pageId,
                            popup: true
                        }
                    })
                    .then(res => resolve(res.data))
                    .catch(e => reject(e))
            })
        },
        fetchFile (onlyMeta = undefined) {
            return this.$axios
                .get(`/v1/files/${this.$route.params.hash}`, {
                    params: {
                        searchPage: this.$route.query.searchPage,
                        searchOrder: this.$route.query.searchOrder,
                        searchToken: this.$route.query.searchToken,
                        ai_message_id: this.$route.query.ai_message_id,
                        page: this.getPage(),
                        onlyMeta
                    }
                })
                .then((res) => {
                    this.data = res.data
                    this.extraModules = this.$auth.loggedIn && this.$auth.user.has_team ? [Chatable] : []
                    this.$store.commit('files/setHistory', null)
                })
                .catch((e) => {
                    if (e.response?.status === 404) {
                        this.message = e.response?.data?.displayMessage ?? this.$t('file viewer file not found')
                        this.msgs.error = this.$t('لم يتم ايجاد الملف')
                        return
                    }
                    if (e.response?.status === 403) {
                        this.message = e.response?.data?.message ?? e.response?.data ??
                            this.$t('ليس لديك صلاحية الوصول.')
                        return
                    }
                    if (e.response?.status === 401) {
                        this.$router.push('/Login')
                        return
                    }
                    this.message =
                        this.$t('لقد حصل خطأ ما.')

                    return Promise.reject(e)
                })
                .finally(() => {
                    if (!onlyMeta) {
                        this.propsLoaded = true
                        this.$nextTick(() => {
                            this.$refs.fileViewer?.setHeaderHeight(this.headerHeight)
                        })
                    }
                })
        },
        savePage (pageId) {
            history?.replaceState({ page: pageId }, null)
        },
        getPageFromUrl () {
            return this.$route?.query?.page && Number.isInteger(parseInt(this.$route?.query?.page)) ? parseInt(this.$route?.query?.page) : null
        },
        getPage () {
            if (typeof history !== 'undefined' && history.state?.page) {
                return history.state?.page
            }

            return this.getPageFromUrl()
        },
        getHistory () {
            const historyId = Number.parseInt(this.$route.query.history)

            return Number.isInteger(historyId) ? historyId : undefined
        },
        getHighlight () {
            const highlightId = Number.parseInt(this.$route.query.highlight)

            return Number.isInteger(highlightId) ? highlightId : undefined
        },
        fvAPI_HighlightCreate ({ hash, page_id, context_id, context_type, color_class, text, note, start_id, end_id, locale, toRemoveIds }) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .post('/v1/highlights', {
                        file_hash: hash,
                        color_class,
                        locale,
                        highlighted_text: text,
                        start_id: start_id.toString(),
                        end_id: end_id.toString(),
                        to_remove_ids: toRemoveIds,
                        page_number: page_id,
                        context_type,
                        context_id,
                        note
                    })
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((e) => {
                        if (e.response?.status === 403) {
                            this.msgs.error = e.response.data
                        }
                        reject(e)
                    })
            })
        },
        fvAPI_HighlightUpdate ({ id, color_class, note }) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .patch(`/v1/highlights/${id}`, {
                        color_class,
                        note
                    })
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((e) => {
                        this.$toast.error(this.$t('لقد حصل خطأ اثناء تحديث الملاحظة'))
                        throw e
                    })
            })
        },
        fvAPI_HighlightDelete ({ id, pageId }) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .delete(`/v1/highlights/${id}`)
                    .then((res) => {
                        resolve()
                    })
            })
        },
        copyText (text) {
            this.$copyText(text)
            this.$toast.success(this.$t('تم النسخ بنجاح'))
        },
        fvAPI_CopySomething ({ item, type }) {
            return new Promise((resolve, reject) => {
                try {
                    if (['link'].includes(type)) {
                        const plain = new Blob([item], { type: 'text/plain' })
                        const data = [new ClipboardItem({'text/plain': plain })]
                        navigator.clipboard.write(data)
                            .then(() => resolve())
                            .catch(e => reject(e))
                    }
                    if (['section', 'history', 'future'].includes(type)) {
                        const blob = new Blob([item.content], { type: 'text/html' })
                        let plain = document.createElement('div')
                        plain.innerHTML = item.content
                        plain = new Blob([plain.textContent], { type: 'text/plain' })
                        const data = [new ClipboardItem({ 'text/html': blob, 'text/plain': plain })]
                        navigator.clipboard.write(data)
                            .then(() => resolve())
                            .catch(e => reject(e))
                    }
                    if (type === 'page') {
                        this.$axios.$get('/v1/files/copy-text', {
                            params: {
                                file_hash: this.data.meta.hash,
                                page_number: item.id,
                                start_id: item.json_text?.paragraphs?.at(0)?.lines?.at(0)?.words?.at(0)?.id,
                                end_id: item.json_text?.paragraphs?.at(-1)?.lines?.at(-1)?.words?.at(-1)?.id
                            }
                        })
                            .then((res) => {
                                this.modal = {
                                    type: 'copyText',
                                    text: res
                                }
                                resolve()
                            })
                            .catch((e) => {
                                reject(e)
                            })
                    }
                } catch (e) {
                    return reject(e)
                }
            })
        },
        fvAPI_HighlightCopy ({ page_id, color, text, note, start_id, end_id, to_remove_ids }) {
            this.toast = this.$toast(this.$t('جار النسخ'), {
                timeout: false,
                closeButton: false,
                icon: LoadingIcon,
                rtl: true,
                closeOnClick: false,
                draggable: false
            })
            this.copyForm.update({
                file_hash: this.data.meta.hash,
                page_number: page_id,
                start_id,
                end_id
            })
            this.copyForm.get('/v1/files/copy-text')
                .then((res) => {
                    this.modal = {
                        type: 'copyText',
                        text: res.data
                    }
                    this.$toast.dismiss(this.toast)
                })
                .catch((e) => {
                    this.msgs.error = this.$t('حصل خطأ الرجاء المحاولة مرة اخرى')
                    throw e
                })
                .finally(() => {
                    this.msgs.success = ''
                    this.msgs.error = ''
                })
        },
        fvAPI_LoadPages ({ fileId, pageId, dir, locales = undefined, loadToken = undefined }) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .get(`/v1/files/${fileId}/loadPage`, {
                        params: { dir, page: pageId, loadToken, locales }
                    })
                    .then((res) => {
                        resolve(res.data.pages)
                    })
                    .catch(e => reject(e))
            })
        },
        buildUrl (link) {
            if (link.includes('http')) {
                return link
            }
            let url = `/File/${link.split('?')[0]}`
            if (link.split('?').length > 1) {
                url += `?${link.split('?')[1]}`
            }

            return url
        },
        linkClick (el) {
            if (el.href.replace(window.location.origin, '') === '/Login') {
                this.$auth.$storage.setUniversal('redirect', this.$router.currentRoute.fullPath)
            }

            if (el.href.startsWith(window.location.origin)) {
                this.$router.push(el.href.replace(window.location.origin, ''))
                return
            }

            window.open(el.href, el.getAttribute('target'))
        },
        getFileName () {
            const defaultName = this.$t('file viewer loading file')

            return this.meta?.name ?? defaultName
        },
        addToMyFolders ({ target }) {
            this.$axios
                .get(`/v1/files/${this.data?.fileInfo?.hash || this.data?.meta?.hash}/addToFolders`, {
                    params: { folder: target?.id }
                })
                .then(({ data }) => {
                    this.$toast.success({
                        component: ShowInMyFolders,
                        props: { text: this.$t('تمت الاضافة بنجاح'), node: data, label: this.$t('عرض في مجلداتي') }
                    })
                })
                .catch((e) => {
                    if (e.response?.status !== 422 && e.response?.status !== 403) {
                        this.$toast.error(this.$t('حصل خطأ اثناء اضافة الملف الى مجلداتك'))
                        throw e
                    }
                    if ('name' in e.response?.data?.errors) {
                        this.$toast.error(e.response?.data?.errors.name[0])
                    }
                })
            this.modal = false
        },
        browseFileInMyFolders () {
            const name = this.data?.fileInfo?.name || this.data?.meta?.name
            this.$router.push('/Folders?exact=true&search=' + name)
            this.modal = false
        },
        fvAPI_SearchInFile (searchText, page = 1, filters = []) {
            return new Promise((resolve, reject) => {
                this.$axios.get(`/v1/files/${this.data.meta.hash}/search`, {
                    params: {
                        text: searchText,
                        page,
                        filters
                    }
                }).then((res) => {
                    resolve(res.data)
                }).catch((e) => {
                    reject(e)
                })
            })
        },
        headerMounted (val) {
            this.headerHeight = val
            this.$refs.fileViewer?.setHeaderHeight(this.headerHeight)
        },
        fvAPI_DownloadFile () {
            this.downloadLoading = true
            this.$axios.get(`/v1/files/${this.data.meta.hash}/download`, { responseType: 'blob' })
                .then((response) => {
                    if (response.data?.type === 'application/json') {
                        return alert(this.$t('لا يسمح بتحميل الملفات اثناء فترة التجربة'))
                    }

                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(response.data)
                    link.download = this.data.meta.name + '.' + this.data.meta.fileExt
                    link.click()
                })
                .finally(() => {
                    this.downloadLoading = false
                })
        },
        fvAPI_DownloadFileLoading () {
            return this.downloadLoading
        }
    }
}
